import { render, staticRenderFns } from "./BOS.vue?vue&type=template&id=818485ba&scoped=true"
import script from "./BOS.vue?vue&type=script&lang=js"
export * from "./BOS.vue?vue&type=script&lang=js"
import style0 from "./BOS.vue?vue&type=style&index=0&id=818485ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818485ba",
  null
  
)

export default component.exports